import { render, staticRenderFns } from "./SoldOut.vue?vue&type=template&id=3de4d219"
import script from "./SoldOut.vue?vue&type=script&lang=js"
export * from "./SoldOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports